import types from './types';

const setUser = (state: any, value: any) => {
  state.user = value;
};

const setOsaId = (state: any, value: any) => {
  state.user.token.osaId = value;
};

const setSupportSelected = (state: any, value: any) => {
  state.user.token.supportSelected = value;
};

export default {
  [types.SET_USER]: setUser,
  [types.SET_OSAID]: setOsaId,
  [types.SET_SUPPORT_SELECTED]: setSupportSelected,
};
